import { Select } from "antd";
import { useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useGetTransactionsGraphQuery } from "../../../features/bsrm/dashboard/dashboardApi";
import useError from "../../../hooks/useError";
import useSelect from "../../../hooks/useSelect";
import { GetTransactionsChartResponseType } from "../../../types/bsrm/dashboard";
import { numberShort, numberWithCommas } from "../../../utils/number";
import { formatSouthAsianNumber } from "../../../utils/utils";

interface Props {
  selectedCategory: any;
  dates: {
    startDate: string | undefined;
    endDate: string | undefined;
  };
  selectedSupplier: any;
}

export default function TransactionsChart({
  selectedCategory,
  dates,
  selectedSupplier,
}: Props) {
  const { dateFilter, select, setSelect } = useSelect();
  const [activeButton, setActiveButton] = useState("dealers");
  const [activeButtonApi, setActiveButtonApi] = useState("dealer");
  const category =
    selectedCategory === "overall" ? activeButton : selectedCategory;

  const {
    data: transactionGraphData,
    isLoading: isTransactionGraphDataLoading,
    isError: isTransactionGraphDataError,
    error: transactionGraphDataError,
    refetch: refetchTransactionGraphData,
  } = useGetTransactionsGraphQuery({
    params: {
      ...dates,
      party: activeButtonApi,
      supplierId: selectedSupplier?.dynamic_id,
      supplierKeyword: selectedSupplier?.dynamic_keyword,
    },
  });

  // const {
  //   data: treaderGraphData,
  //   isLoading: traderGraphLoading,
  //   isError,
  //   error,
  // } = useGetTradersSummeryQuery({
  //   ...(select ? { ...dateFilter } : {}),
  // });

  // const {
  //   data: treaderGraphData,
  //   isLoading: traderGraphLoading,
  //   isError,
  //   error,
  // } = useGetTradersSummeryQuery({
  //   ...dates,
  //   limit: 1000,
  // });

  const totalAmountData = transactionGraphData?.data
    .map((item) => {
      return {
        date: !item.date || item.date === null ? "" : item.date,
        totalAmount: item.totalAmount,
      };
    })
    .filter((item) => item.date && item.date !== "null" && item.date !== "-")
    ?.sort((a, b) => {
      const dateA = a.date ? new Date(a.date) : null;
      const dateB = b.date ? new Date(b.date) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA.getTime() - dateB.getTime();
    });

  // const totalTreaderAmountData = treaderGraphData?.data?.rows
  //   ?.map((item) => {
  //     return {
  //       date: !item.createdAt || item.createdAt === null ? "" : item.createdAt,
  //       totalAmount: item.tradersToSupplierTransactionAmount,
  //     };
  //   })
  //   .filter((item) => item.date && item.date !== "null" && item.date !== "-")
  //   ?.sort((a, b) => {
  //     const dateA = a.date ? new Date(a.date) : null;
  //     const dateB = b.date ? new Date(b.date) : null;

  //     if (!dateA && !dateB) return 0;
  //     if (!dateA) return 1;
  //     if (!dateB) return -1;

  //     return dateA.getTime() - dateB.getTime();
  //   });

  const totalTransactionsData = transactionGraphData?.data
    .map((item) => {
      return {
        date: !item.date || item.date === "null" ? "-" : item.date,
        totalTransactions: item.totalTransactions,
      };
    })
    .filter((item) => item.date && item.date !== "null" && item.date !== "-")
    ?.sort((a, b) => {
      const dateA = a.date ? new Date(a.date) : null;
      const dateB = b.date ? new Date(b.date) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA.getTime() - dateB.getTime();
    });

  // const totalTreaderTransactionData = treaderGraphData?.data?.rows
  //   ?.map((item) => {
  //     return {
  //       date: !item.createdAt || item.createdAt === null ? "" : item.createdAt,
  //       totalTransactions: item.tradersToSupplierTransactionCount,
  //     };
  //   })
  //   .filter((item) => item.date && item.date !== "null" && item.date !== "-")
  //   ?.sort((a, b) => {
  //     const dateA = a.date ? new Date(a.date) : null;
  //     const dateB = b.date ? new Date(b.date) : null;

  //     if (!dateA && !dateB) return 0;
  //     if (!dateA) return 1;
  //     if (!dateB) return -1;

  //     return dateA.getTime() - dateB.getTime();
  //   });

  useError(
    isTransactionGraphDataError,
    transactionGraphDataError,
    "Get transactions data fail"
  );

  // useError(isError, error, "Get transactions data fail");

  function totalAmount(
    item: keyof Omit<GetTransactionsChartResponseType["data"][0], "date">
  ) {
    return formatSouthAsianNumber(
      transactionGraphData?.data?.reduce(
        (acc, curr) => acc + curr?.[item] || 0,
        0
      ) || 0
    );
  }

  // function totalTreaderAmount(item: keyof TraderDetailsData) {
  //   return formatSouthAsianNumber(
  //     treaderGraphData?.data?.rows?.reduce((acc, curr) => {
  //       return acc + Number(curr?.[item]) || 0;
  //     }, 0) || 0
  //   );
  // }

  // const getTransactionTitle = () => {
  //   if (selectedCategory === "dealers") {
  //     return "Transactions of Dealers";
  //   }
  //   if (selectedCategory === "traders") {
  //     return "Transactions of Traders";
  //   }
  //   if (selectedCategory === "retailers") {
  //     return "Transactions of Tetailers";
  //   }
  //   if (selectedCategory === "overall") {
  //     return activeButton === "traders"
  //       ? "Transactions of Traders"
  //       : "Transactions of Dealers";
  //   }
  //   return "";
  // };

  const getTransactionTitle = () => {
    if (selectedCategory === "dealers") {
      return "Transactions of Dealers";
    }
    if (selectedCategory === "traders") {
      return "Transactions of Traders";
    }
    if (selectedCategory === "retailers") {
      return "Transactions of Retailers";
    }
    if (selectedCategory === "overall") {
      if (activeButton === "dealers") {
        return "Transactions of Dealers";
      }
      if (activeButton === "traders") {
        return "Transactions of Traders";
      }
      if (activeButton === "retailers") {
        return "Transactions of Retailers";
      }
    }
    return "";
  };

  useEffect(() => {
    if (selectedCategory === "traders") {
      setActiveButtonApi("trader");
      refetchTransactionGraphData();
    } else if (selectedCategory === "dealers") {
      setActiveButtonApi("dealer");
      refetchTransactionGraphData();
    } else if (selectedCategory === "retailers") {
      setActiveButtonApi("retailer");
      refetchTransactionGraphData();
    }
  }, [selectedCategory, refetchTransactionGraphData]);

  // console.log("transactionGraphData:", transactionGraphData);

  return (
    <div className="lg:col-span-2 p-4 rounded-md dark:bg-primaryBackground bg:white !dark:border-[#cccccc] !border-[#cccccc] border border-solid">
      <div>
        <div className="flex justify-between items-center">
          <div className="text-2xl dark:text-header text-others-table-header">
            {getTransactionTitle()}
          </div>

          {/* {selectedCategory === "overall" && (
            <div className="h-10 px-1.5 rounded-lg outline outline-1 outline-offset-[-1px] outline-slate-400 inline-flex justify-start items-center gap-2">
           
              <button
                onClick={() => {
                  setActiveButton("dealers");
                  setActiveButtonApi("dealer");
                }}
                className={`h-8 px-3 rounded-md flex justify-start items-center text-base font-medium cursor-pointer ${
                  activeButton === "dealers"
                    ? "bg-blue-600 text-white !border-none !hover:border-none !hover:text-white"
                    : "!bg-transparent !border-none !hover:bg-transparent !hover:border-none text-slate-700"
                }`}
              >
                Dealers
              </button>

       
              <button
                onClick={() => {
                  setActiveButton("traders");
                  setActiveButtonApi("trader");
                }}
                className={`h-8 px-3 rounded-md flex justify-start items-center text-base font-medium cursor-pointer ${
                  activeButton === "traders"
                    ? "bg-blue-600 text-white !border-none !hover:border-none !hover:text-white"
                    : "!bg-transparent !border-none !hover:bg-transparent !hover:border-none text-slate-700"
                }`}
              >
                Traders
              </button>

        
              <button
                onClick={() => {
                  setActiveButton("retailers");
                  setActiveButtonApi("retailer");
                }}
                className={`h-8 px-3 rounded-md flex justify-start items-center text-base font-medium cursor-pointer ${
                  activeButton === "retailers"
                    ? "bg-blue-600 text-white !border-none !hover:border-none !hover:text-white"
                    : "!bg-transparent !border-none !hover:bg-transparent !hover:border-none text-slate-700"
                }`}
              >
                Retailers
              </button>
            </div>
          )} */}

          {selectedCategory === "overall" && (
            <Select
              className="min-w-[150px]"
              value={activeButton}
              onChange={(value) => {
                setActiveButton(value);
                // Map to API-friendly version
                const apiMap: Record<string, string> = {
                  dealers: "dealer",
                  traders: "trader",
                  retailers: "retailer",
                };
                setActiveButtonApi(apiMap[value]);
              }}
              options={[
                { value: "dealers", label: "Dealers" },
                { value: "traders", label: "Traders" },
                { value: "retailers", label: "Retailers" },
              ]}
              dropdownStyle={{
                borderRadius: 8,
              }}
              popupMatchSelectWidth={false}
            />
          )}
        </div>
        <div className="flex gap-6 my-4">
          <div className="flex gap-2">
            <div className="mt-1 h-3 w-3 bg-[#FFB907] rounded-full"></div>
            <div>
              <div className="text-sm dark:text-body text-others-header">
                Total Value
              </div>
              <div className="text-2xl dark:text-header text-others-table-header">
                ৳{totalAmount("totalAmount")}
              </div>
            </div>
          </div>
          <div className="flex gap-2">
            <div className="mt-1 h-3 w-3 bg-[#29BF5B] rounded-full"></div>
            <div>
              <div className="text-sm  dark:text-body text-others-header">
                Total Transactions
              </div>
              <div className="text-2xl dark:text-header text-others-table-header">
                {totalAmount("totalTransactions")}
              </div>
            </div>
          </div>
        </div>

        {isTransactionGraphDataLoading ? (
          <div className="h-[300px] w-full bg-slate-100"></div>
        ) : (
          <div>
            <ResponsiveContainer width={"100%"} height={300}>
              <BarChart data={totalAmountData}>
                {/* <CartesianGrid strokeDasharray="3 3" /> */}
                <XAxis
                  dataKey="date"
                  tickFormatter={(date) => {
                    return !date || date === "null"
                      ? ""
                      : new Date(date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        });
                  }}
                  style={{
                    fontSize: 12,
                  }}
                />
                <YAxis
                  dataKey="totalAmount"
                  tickFormatter={(val) => `${numberShort(val || 0)}`}
                />
                {/* <Tooltip
                  formatter={(val) =>
                    numberWithCommas(Number(val) || 0)?.toString()
                  }
                  content={<CustomTooltip />}
                /> */}

                <Tooltip
                  formatter={(value) => [
                    `Total Amount: ${numberWithCommas(Number(value) || 0)} TK`,
                  ]}
                  labelFormatter={(label) =>
                    new Date(label).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                  }
                />
                <Legend />
                <Bar dataKey="totalAmount" fill="#ffb907" name="Total Amount" />
              </BarChart>
            </ResponsiveContainer>

            <ResponsiveContainer width={"100%"} height={300}>
              <BarChart data={totalTransactionsData}>
                {/* <CartesianGrid strokeDasharray="10 10" /> */}
                <XAxis
                  dataKey="date"
                  tickFormatter={(date) => {
                    return !date || date === "null"
                      ? ""
                      : new Date(date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        });
                  }}
                  style={{
                    fontSize: 12,
                  }}
                />
                <YAxis
                  dataKey="totalTransactions"
                  tickFormatter={(val) => numberShort(val || 0)}
                />
                <Tooltip
                  formatter={(val) =>
                    numberWithCommas(Number(val) || 0)?.toString()
                  }
                  content={<CustomTooltip />}
                />
                <Legend />
                <Bar
                  dataKey="totalTransactions"
                  fill="#29bf5b"
                  name="Total Transactions"
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white rounded-md p-4">
        {label && label !== "null" && <p className="label">{`${label}`}</p>}
        {payload.map((entry: any, index: number) => (
          <p key={`item-${index}`} style={{ color: entry.color }}>
            {`${entry.name}: ${formatSouthAsianNumber(entry.value)}`}
          </p>
        ))}
      </div>
    );
  }

  return null;
};
